import React, { useState } from "react";
import { Container, Tab, Tabs, Nav } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers, faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import TeamsTab from "./TeamsTab";
import ChannelTab from "./ChannelTab";

type TabType = "teams" | "channel";

const TeamDashboard = () => {
  const [activeTab, setActiveTab] = useState<TabType>("teams");

  return (
    <>
      {/* Tab Navigation */}
      <div className="">
        <Tab.Container
          id="left-tabs-example"
          defaultActiveKey="teams"
          activeKey={activeTab}
          onSelect={(k) => setActiveTab(k as TabType)}
        >
          {/* <div className="d-flex">
            <Nav variant="pills" className="common_tab">
              <Nav.Item>
                <Nav.Link eventKey="teams">Teams</Nav.Link>
              </Nav.Item>
              <Nav.Item>
                <Nav.Link eventKey="channel">Channel</Nav.Link>
              </Nav.Item>
            </Nav>
          </div> */}
          <Tab.Content className="">
            {/* common_content_inner mby_t_16 */}
            <Tab.Pane eventKey="teams">
              {activeTab === "teams" && <TeamsTab />}
            </Tab.Pane>
            <Tab.Pane eventKey="channel">
              {activeTab === "channel" && <ChannelTab />}
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>

        {/* <Tabs
                    activeKey={activeTab}
                    onSelect={(k) => setActiveTab(k as TabType)}
                    className="common_tab"
                >
                    <Tab
                        eventKey="teams"
                        title={
                            <span className="d-flex align-items-center gap-2">
                                <FontAwesomeIcon icon={faUsers} size="sm" />
                                Teams
                            </span>
                        }
                    >
                        <div className="p-4">
                            {activeTab === "teams" && <TeamsTab />}
                        </div>
                    </Tab>
                    <Tab
                        eventKey="channel"
                        title={
                            <span className="d-flex align-items-center gap-2">
                                <FontAwesomeIcon icon={faFolderOpen} size="sm" />
                                Channel
                            </span>
                        }
                    >
                        <div className="p-4">
                            {activeTab === "channel" &&
                                <ChannelTab />
                            }
                        </div>
                    </Tab>
                </Tabs> */}
      </div>
    </>
  );
};

export default TeamDashboard;
